import LabPage from "../components/layout/LabPage";
import { Rocket, Wand2, Mail, MessageSquare, Calendar, Megaphone, Globe, Workflow } from "lucide-react";

export default function LaunchLab() {
  return (
    <LabPage
      testId="launch-lab-page"
      kicker="LaunchLab"
      title="Turn assets into campaigns"
      description="Plan a launch, generate landing copy, emails, SMS, ads, social posts, and reminder sequences — all aligned to one offer."
      heroImage="https://images.unsplash.com/photo-1556761175-4b46a572b786?w=900&q=80"
      heroTone="lime"
      actions={[{ label: "Plan a Launch", icon: Wand2, to: "/create" }]}
      quickActions={[
        { label: "Landing Copy", icon: Globe },
        { label: "Email Sequence", icon: Mail },
        { label: "SMS Reminders", icon: MessageSquare },
        { label: "Calendar", icon: Calendar },
      ]}
      features={[
        { icon: Rocket, title: "11 Campaign Types", description: "Webinar, replay, book launch, lead magnet, challenge, cart open/close." },
        { icon: Megaphone, title: "Ad Copy", description: "Hooks, angles, audiences — built for paid amplification." },
        { icon: Workflow, title: "Auto-link to AutomationLab", description: "Send sequences live with one click." },
        { icon: Calendar, title: "Launch Calendar", description: "Daily plan from registration → live → replay → cart close." },
        { icon: Mail, title: "Email Sequences", description: "Nurture, reminders, replay, cart close emails." },
        { icon: MessageSquare, title: "SMS Sequences", description: "Quiet hours, STOP/HELP, opt-out — compliant by design." },
      ]}
      sampleAssets={[
        { title: "Authority Webinar Launch", thumb: "https://images.unsplash.com/photo-1542744095-291d1f67b221?w=500&q=80", meta: "4-week plan" },
        { title: "Book Launch Sprint", thumb: "https://images.unsplash.com/photo-1495446815901-a7297e633e8d?w=500&q=80", meta: "Cart open" },
        { title: "5-Day Challenge", thumb: "https://images.unsplash.com/photo-1556761175-4b46a572b786?w=500&q=80", meta: "Reminder loop" },
        { title: "VIP Coaching Offer", thumb: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=500&q=80", meta: "Live" },
      ]}
    />
  );
}
